import { getKyClient } from './client';

export const fetchFeatureFlags = async () => {
  let url = `v1/FeatureFlags`;

  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};
